import { toast } from 'sonner'

import { employersRenewalsRenewalsV2 } from 'rails_routes'
import { Button } from 'slab'

export default function ShareRenewalQuote () {
  const handleCopyLink = async () => {
    const path = employersRenewalsRenewalsV2.exploreSmartAllowances()
    const fullUrl = `${window.location.origin}${path}`
    try {
      await navigator.clipboard.writeText(fullUrl)
      toast.success('Renewal quote link copied to clipboard!')
    } catch {
      toast.error('Failed to copy renewal quote link')
    }
  }

  return (
    <Button
      variant='primary'
      onClick={handleCopyLink}
    >
      Copy renewal quote link
    </Button>
  )
}
